// extracted by mini-css-extract-plugin
module.exports = {"listing_detail":"test_and_room_listing_listing_detail__3BsWg","listing_heading":"test_and_room_listing_listing_heading__1mfdd"};